import { render, staticRenderFns } from "./ReportsDrawer.vue?vue&type=template&id=54b75a1c"
import script from "./ReportsDrawer.vue?vue&type=script&lang=js"
export * from "./ReportsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports